import * as React from "react";
import { UitkBanner } from "@egds/react-core/banner";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
import { UitkIcon } from "@egds/react-core/icons";

import { UitkHeading, UitkText } from "@egds/react-core/text";

export interface MapMessageProps {
  /**
   * Event callback when the user clicks on the close button
   */
  onDismiss(): void;

  /**
   * Error message
   */
  message: string;

  /**
   * Error title
   */
  heading: string;
}

/**
 * Adds an error message over the map. Useful when you need to show
 * error statuses when the map is opened.
 *
 * @param {MapMessageProps} props
 */
export const EGMapErrorMessage: React.FC<MapMessageProps> = ({ message, heading, onDismiss }) => (
  <UitkLayoutPosition type="absolute" onClick={onDismiss} position={{ bottom: "twelve", left: "center" }}>
    <UitkBanner>
      <UitkIcon name="info_outline" spotlight={{ theme: "standard", background: false }} />
      <UitkHeading tag="h4">{heading}</UitkHeading>
      <UitkText>{message}</UitkText>
    </UitkBanner>
  </UitkLayoutPosition>
);

EGMapErrorMessage.displayName = "EGMapErrorMessage";
